import { makeStyles } from '@rbx/ui';

const useNotificationBellStyles = makeStyles()((theme) => ({
  container: {
    borderRadius: 8,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  expanded: {
    backgroundColor: theme.palette.states.focus,
  },

  hidden: {
    display: 'none',
    pointerEvents: 'none',
  },

  gridContainer: {
    [theme.breakpoints.down('Medium')]: { paddingTop: 4, paddingBottom: 4 },
  },
}));

export default useNotificationBellStyles;
